const GOOGLE_MAPS_EMBED_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_EMBED_API_KEY || '';
const hasMapsEmbedKey = Boolean(GOOGLE_MAPS_EMBED_API_KEY);

const AUThed_EMBED_BASE = 'https://www.google.com/maps/embed/v1';
const UNIVERSAL_EMBED_BASE = 'https://www.google.com/maps';

function encodeParams(params) {
  return Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join('&');
}

function buildAuthedUrl(modePath, params) {
  const searchParams = encodeParams({ key: GOOGLE_MAPS_EMBED_API_KEY, ...params });
  return `${AUThed_EMBED_BASE}/${modePath}?${searchParams}`;
}

function buildSearchEmbedUrl(query, opts = {}) {
  if (!hasMapsEmbedKey) {
    // Fallback universal embed (no API key needed)
    const q = (query || '').trim();
    if (!q) return '';
    const searchParams = encodeParams({ q, output: 'embed' });
    return `${UNIVERSAL_EMBED_BASE}?${searchParams}`;
  }

  const q = (query || '').trim();
  if (!q) return '';
  const { zoom, maptype, language, region } = opts;
  return buildAuthedUrl('search', { q, zoom, maptype, language, region });
}

function buildPlaceIdEmbedUrl(placeId, opts = {}) {
  if (!hasMapsEmbedKey) {
    // Without a key, place_id is not supported in universal embed.
    // Fall back to a generic search that is unlikely to match well.
    return '';
  }
  const pid = (placeId || '').trim();
  if (!pid) return '';
  const { zoom, maptype, language, region } = opts;
  return buildAuthedUrl('place', { q: `place_id:${pid}`, zoom, maptype, language, region });
}

function buildEmbedUrl(params = {}) {
  const { query, placeId, zoom, mapType, language, region } = params;
  const opts = { zoom, maptype: mapType, language, region };

  if (placeId && hasMapsEmbedKey) {
    const url = buildPlaceIdEmbedUrl(placeId, opts);
    if (url) return url;
  }
  if (query) {
    return buildSearchEmbedUrl(query, opts);
  }
  return '';
}

const maps = {
  GOOGLE_MAPS_EMBED_API_KEY,
  hasMapsEmbedKey,
  buildEmbedUrl,
  buildSearchEmbedUrl,
  buildPlaceIdEmbedUrl
};

export {
  GOOGLE_MAPS_EMBED_API_KEY,
  hasMapsEmbedKey,
  buildEmbedUrl,
  buildSearchEmbedUrl,
  buildPlaceIdEmbedUrl
};

export default maps;
